<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 11:25:57
 * @LastEditTime: 2024-06-05 11:02:36
 * @LastEditors: 张天昊
 * @Description: 餐饮卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/CateringCard.vue
-->
<script>
import { defineComponent, ref } from 'vue';
import CardContainer from './CardContainer.vue';
import Description from './Description.vue';
import { genEmptyTextPlaceholder } from '../utils';

export default defineComponent({
  components: {
    CardContainer,
    Description
  },
  props: {
    data: {
      // {
      //   title: '2024/04/20',
      //   breakfast: '',
      //   lunch: '大理古城云梦餐厅',
      //   dinner: '洱海好客莱餐厅'
      // },
      type: Array,
      default: () => []
    }
  },
  setup() {
    return {
      genEmptyTextPlaceholder
    };
  }
});
</script>

<template>
  <CardContainer>
    <template v-for="(item, index) in data">
      <van-divider v-if="index" :key="index" class="custom-divider" />
      <div :key="item.title + index">
        <div class="text-16 leading-20 font-medium">{{ item.title }}</div>
        <Description
          class="mt-4"
          label="早"
          :content="genEmptyTextPlaceholder(item.breakfast)"
        />
        <Description
          class="mt-8"
          label="中"
          :content="genEmptyTextPlaceholder(item.lunch)"
        />
        <Description
          class="mt-8"
          label="晚"
          :content="genEmptyTextPlaceholder(item.dinner)"
        />
      </div>
    </template>
  </CardContainer>
</template>

<style lang="less" scoped>
.custom-divider {
  margin: 12px 0;
}
</style>
